define('merchandising_zone_cell_template.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('merchandising_zone_cell_template', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li  class=\"merchandising-zone-cell-template\"><div data-type=\"backbone.collection.view.cell\"></div></li>  ";
},"useData":true}, 'extensions/SC/Posh/3.5.5/', 'extensions/SC/Posh/3.5.5/', Handlebars);
});